import React from "react";

const MarqueeSection = () => {
  const newsItems = [
    {
      title: "University Grants Commission – Code of Professional Ethics",
      link: "https://care.edu.in/wp-content/uploads/2021/12/University-Grants-Commission-Code-of-Professional-Ethics.pdf",
    },
    {
      title:
        "National Medical Commission / Medical Council of India – Professional Conduct, Etiquette and Ethics",
      link: "https://care.edu.in/wp-content/uploads/2021/12/Medical-Council-of-India-code-of-conduct.pdf",
    },
    {
      title: "Indian Nursing Council – Professional Code of Ethics",
      link: "https://care.edu.in/wp-content/uploads/2021/12/Indian-Nursing-Council-Professional-code-of-ethics.pdf",
    },
  ];

  // Duplicate items to create seamless looping effect
  const duplicatedItems = [...newsItems, ...newsItems, ...newsItems];

  return (
   <section className="code_of_conduct codeconduct-section pt_80">
      <div className="container">
        <div className="row d-flex d-lg-flex justify-content-lg-center align-items-lg-center">
          {/* Commented out the title column as per your HTML structure */}
          {/* <div className="col-md-6 col-12">
            <h1 className="text-center sports-head mb-md-3 mb-5 mt-3">
              Code Of Conduct & Code Of Ethics
            </h1>
          </div> */}

          <div className="col-md-1 col-5 mb-2 mb-md-0">
            {/* This is the corrected line. 
              Changed "trending-label-coc" to "trending-label" 
              to match your CSS.
            */}
            <div className="text-center trending-label-coc">Latest News</div>
          </div>

          <div className="col-md-11 col-12">
            <div className="marquee-wrapper">
              <div className="marquee-content">
                {duplicatedItems.map((item, index) => (
                  <div key={index} className="marquee-item">
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.title}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarqueeSection;